<template>
  <div class="scheduleContainer">
    <div
      v-for="schedule in scheduleList"
      :key="schedule.id"
    >
      <q-btn
        :disable="isHourSoldOut(schedule.id)"
        @click="clickSelectHour(schedule)"
      >
        <div class="btn-content">
          <span :class="{scheduleLabel: true, longLabel: `${schedule.label}`.length > 5}">
            {{ schedule.label }}
          </span>
          <availability-label
            v-if="showAvailability && schedule.available > 0"
            :availability="schedule.available"
            :last-tickets-max-qty="lastTicketsMaxQty"
          />
        </div>
      </q-btn>
      <sold-out-icon
        v-if="isHourSoldOut(schedule.id)"
        place-on-right-corner
      />
      <discount-icon
        v-else-if="hourHasDiscount(schedule.id)"
        place-on-right-corner
      />
    </div>
    <div
      v-if="hasAnyDiscount || hasAnySoldOut"
      class="legendWrapper"
    >
      <calendar-legend
        :discount="hasAnyDiscount"
        :sold-out="hasAnySoldOut"
        :availability="showAvailability"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ScheduleList',
    components: {
      DiscountIcon: () => import('./DiscountIcon'),
      SoldOutIcon: () => import('./SoldOutIcon'),
      CalendarLegend: () => import('./CalendarLegend'),
      AvailabilityLabel: () => import('./AvailabilityLabel'),
    },
    props: {
      scheduleList: {
        type: Array,
        required: true,
      },
      hourHasDiscount: {
        type: Function,
        required: true,
      },
      isHourSoldOut: {
        type: Function,
        required: true,
      },
      isHourLastTickets: {
        type: Function,
        required: true,
      },
      clickSelectHour: {
        type: Function,
        required: true,
      },
      showAvailability: {
        type: Boolean,
        required: true,
      },
      lastTicketsMaxQty: {
        type: Number,
        required: true,
      },
    },
    computed: {
      hasAnyDiscount() {
        return this.scheduleList.some((schedule) => this.hourHasDiscount(schedule.id));
      },
      hasAnySoldOut() {
        return this.scheduleList.some((schedule) => this.isHourSoldOut(schedule.id));
      },
    },
  };
</script>

<style scoped lang="stylus">
.scheduleContainer
  display: flex
  justify-content: center
  align-items: center
  flex-wrap: wrap
  & > div
    position: relative
    margin: 5px
    flex-grow: 0
    &.legendWrapper
      flex-grow: 1
      flex-basis: 100%
      flex-shrink: 0
  .q-btn
    border-radius: .25em !important
    width: 100px
    text-transform: lowercase
    .btn-content
      display: flex
      flex-direction: column
      .scheduleLabel
        white-space: nowrap
        &.longLabel
          font-size: .8em
</style>
